import styled from "styled-components";
import { Button as AntButton } from 'antd'
import { lightTheme } from '@styles'
export const ModalTitle = styled.p`
  color: ${lightTheme.primary};
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 26px;
`;

export const ModalLabel = styled.p`
  font-size: 14px;
  text-align: center;
  margin-top: 20px;
`;

export const Button = styled(AntButton)`
    width: 100%;
    height: 50px;
    margin-top: 20px;
`;